import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const EditWalletPage = () => {
  const [data, setData] = useState({
    trust_wallet: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_editwallet_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_editwallet_card"
      >
        <div className="mono_editwallet_title">
          <h2>Update mono Wallet Address</h2>
        </div>
        <div className="mono_editwallet_field">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Mono Trust Wallet Address"
                type="text"
                value={data.trust_wallet}
                name="trust_wallet"
                onChange={(e) =>
                  setData({ ...data, trust_wallet: e.target.value })
                }
                placeholder="Enter trust wallet address"
              />
            </div>
            <div className="form_group">
              <h4>Mono Contract Address</h4>
              <p>0xdd0ee904dc db9d4fcbeaa b28ed1f806 a16ce7ba9</p>
            </div>
            <Button type="submit" className="editwallet_btn">
              submit
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default EditWalletPage;
